import { inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConfirmationService } from 'primeng/api';

@Injectable()
export class OktaTokenInterceptor implements HttpInterceptor {
  private _confirmationService = inject(ConfirmationService);

  private readonly _msg = 'Token failed validation';

  public intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error &&
          error.status === 500 &&
          (error.error?.message?.includes(this._msg) ||
            error.message?.includes(this._msg))
        ) {
          this._confirmationService.confirm({
            header: 'Session expired',
            key: 'session-expired',
            icon: 'ti ti-alert-triangle',
            message:
              'Your session has expired or is invalid. Please reload to log in again.',
            acceptLabel: 'Reload',
            acceptIcon: 'none',
            rejectVisible: false,
            accept: () => {
              window.location.reload();
            }
          });

          return of();
        }

        return throwError(() => error);
      })
    );
  }
}
